import XCovered from './XCovered';

export default XCovered;
